import PropTypes from 'prop-types';
import { useState } from 'react';

// material-ui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  Stack
} from '@mui/material';

// assets
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';

// ==============================|| LOGOUT CONFIRMATION DIALOG ||============================== //

export default function LogoutConfirmation({ open, onClose, onConfirm, isLoading = false }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={2}>
          <LogoutOutlined style={{ fontSize: '1.5rem', color: '#f44336' }} />
          <Typography variant="h6">Confirmer la déconnexion</Typography>
        </Stack>
      </DialogTitle>
      
      <DialogContent>
        <DialogContentText>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Êtes-vous sûr de vouloir vous déconnecter ?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Vous devrez vous reconnecter pour accéder à nouveau à l'application.
          </Typography>
        </DialogContentText>
      </DialogContent>
      
      <DialogActions sx={{ p: 3 }}>
        <Button 
          onClick={onClose} 
          disabled={isLoading}
          variant="outlined"
        >
          Annuler
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={isLoading}
          startIcon={<LogoutOutlined />}
        >
          {isLoading ? 'Déconnexion...' : 'Se déconnecter'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

LogoutConfirmation.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};
